/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-06-01 10:00:29
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-07-28 16:14:51
 * @Notes:
 */
import { init, RematchDispatch, RematchRootState } from "@rematch/core";
// import selectorsPlugin from "@rematch/select";
import immerPlugin from "@rematch/immer";
import createLoadingPlugin from "@rematch/loading";
// import updatedPlugin from "@rematch/updated";

import { models, RootModel } from "./models";

// see options API below
const loadingOptions = {
  whiteList: [], //  "modelName" / "actionName"
  blacklist: [],
};
const loading = createLoadingPlugin(loadingOptions);
// const updated = updatedPlugin();
const immer = immerPlugin();
// const select = selectorsPlugin();

interface ILoadingPlugin {
  loading: {
    global: boolean;
    models: RematchRootState<RootModel>;
    effects: RootDispatch;
  };
}

export type Store = typeof store;
export type RootState = RematchRootState<RootModel> & ILoadingPlugin;
export type RootDispatch = RematchDispatch<RootModel>;
// export type RootSelect = RematchRootSelect<typeof models>;

// 初始化store
export const store = init({
  models: {
    ...models,
  },
  plugins: [loading, immer],
});
